import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { FormTemplateDataEntryService } from './../services/form-template-data-entry.service';
//import { ItemDataService } from './../services/item-data.service';
import { IDataEntryForm } from './../models/data-entry.model';
import { ZenplansTestDataProviderService } from './../services/zenplans-test-data-provider.service';
import { IUrlParameter } from './../models/data-entry.model';
import { TextDictionaryService } from './../services/text-dictionary.service';
import textList from '../../assets/data/text-dictionary.json';
import countries from '../../assets/data/countries.json';
import { NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { DynamicHelpers } from './../helpers/dynamic-helpers';

@Component({
  selector: 'app-dynamic-edit',
  //templateUrl: './dynamic-edit.component.html',
  templateUrl: './../dynamic-form-data-entry/dynamic-form-data-entry.component.html',
  styleUrls: ['./../dynamic-form-data-entry/dynamic-form-data-entry.component.scss']
})
export class DynamicEditComponent {
  myFormGroup: FormGroup = new FormGroup({});
  myFormTemplate: IDataEntryForm;
  templateName;
  Id;
  myItem = {};
  sectionTitle = "";
  showHelp = false;
  submitted = false;
  myTextList = textList;
  myCountries = countries;
  subscription;
  buttonText = "Save Changes";
  myOptionItem;
  otherFreeText = false;
  message: string;
  showList = false;
  hideList: string[] = [];
  editMode = true;
  dummyShowTrigger: boolean = false;
  //datePicker: NgbDateStruct;
  date: { year: number, month: number };
  currentReview;
  // hoveredDate: NgbDate;
  // fromDate: NgbDate;
  // toDate: NgbDate;



  constructor(private activatedRoute: ActivatedRoute, private router: Router,
    private ftService: FormTemplateDataEntryService, private dictService: TextDictionaryService,
    private zenplansTestDataProviderService: ZenplansTestDataProviderService,
    private fb: FormBuilder, private calendar: NgbCalendar) {
    console.log("start constructor");
    this.activatedRoute.paramMap.subscribe(params => {
      this.templateName = params.get('templateName');
      this.Id = params.get('Id');
      this.OnInit();
      //this.getFields();
    });
  }

  async OnInit() {
    console.log("start oninit");
    this.myFormTemplate = await this.ftService.getFormTemplateAsync(this.templateName);
    this.myItem = await this.zenplansTestDataProviderService.getItem(this.Id, this.myFormTemplate.sectionTitle);
    await this.getFields();
  };

  async getFields() {

    //adding fields to group for sending to save
    this.sectionTitle = this.myFormTemplate.sectionTitle; //await this.getText(this.myFormTemplate.sectionTitle);
    this.myFormGroup.addControl("clientId", new FormControl(''));
    this.myFormGroup.addControl("Id", new FormControl(this.Id));
    // this.myFormGroup.addControl("lastUpdate", new FormControl(''));
    // this.myFormGroup.addControl("lastUpdateBy", new FormControl(''));
    //above looks like a boo boo. They may have values from the last edit.
    //TODO - fill in the above values from the object keys and values below.
    var objectKeys = Object.keys(this.myItem);
    var objectValues = Object.values(this.myItem);
    //this.myFormGroup.addControl("Id", new FormControl(this.Id));
    //fill existing "upToDateExpire"
    var sonIndex = objectKeys.findIndex(jj => jj.toLowerCase() === "uptodateexpire");
    let myVal = objectValues[sonIndex] as string;
    if (myVal && myVal.length > 0) {
      this.myFormGroup.addControl("upToDateExpire", new FormControl(myVal));
    }
    var myValue;
    this.myFormTemplate.fields.forEach(async templateObject => {
      myValue = "";
      var mySonList;
      var index = objectKeys.findIndex(ff => ff.toLowerCase() == templateObject.fieldid.toLowerCase());
      var fieldValue = objectValues[index] as string;
      if (fieldValue) {
        myValue = fieldValue;
        if (templateObject.fieldid.toLowerCase() == "review") {
          //to check if the user changed the review period so we know to recalculate the upToDateExpire
          //Question - maybe we need to recalulate upToDateExpire based on what it ws before?
          this.currentReview = fieldValue;
        }
      }

      if (templateObject.inputtype == "radiobuttons") {
        //finding the saved value of the radio button
        if (templateObject.urlparameters) {
          templateObject.urlparameters.forEach(up => {
            var sonIndex = objectKeys.findIndex(jj => jj.toLowerCase() === templateObject.fieldid.toLowerCase());
            let myVal = objectValues[sonIndex] as string;
            if (myVal && myVal.length > 0) {
              myValue = myVal;
            }
          });
        }
      }

      //If a option for show other fields in the show fields list, don't add those fields to the hideList.
      //Only if the saved option has an action of "hide"
      if (templateObject.showFields) {
        if (templateObject.inputtype == "radiobuttonsshow") {
          templateObject.options.forEach(option => {
            if (option["option"] == myValue && option["action"] == "hide") {
              templateObject.showFields.map(field => {
                //this.myFormGroup.controls[field].disable();
                this.hideList.push(field);
              });
            }
          })
        }
        else {
          templateObject.showFields.map(field => {
            //this.myFormGroup.controls[field].disable();
            this.hideList.push(field);
          })
        }


      }
      if (templateObject.inputtype.includes("conditionaldropdown")) {
        //adding urls in urlparamters that are fields to the hidelist so they won't show up on init
        templateObject.urlparameters.forEach(element => {
          if (element.urlArray) {
            element.urlArray.forEach(url => {
              // let kk = this.myFormTemplate.fields.find(field => {
              //   field.fieldid == url;
              // });
              // if (kk) {
              if (url.length > 0) {
                this.hideList.push(url);
              }
              //}
            });
          }

        })
      }
      if (templateObject.mandatory && templateObject.inputtype != "conditionaldropdown"
        && templateObject.inputtype != "formarray"
        && templateObject.inputtype != "formarraytwocolumns"
        && templateObject.inputtype != "formarraythreecolumns"
        && templateObject.inputtype != "formarrayfourcolumns") {
        this.myFormGroup.addControl(templateObject.fieldid, new FormControl(myValue, Validators.required));
      }
      else {
        switch (templateObject.inputtype) {
          case "formarray": {
            let myIndex = objectKeys.findIndex(ff => ff.toLowerCase() == templateObject.fieldid.toLowerCase());
            mySonList = objectValues[myIndex] as [];
            templateObject.sonListItems = mySonList;
            var myFormArray = [];
            mySonList.map(value => {
              let myControl = this.fb.control(value);
              myFormArray.push(myControl);
            })
            this.myFormGroup.addControl(templateObject.fieldid, new FormArray(myFormArray));
            break;
          }
          case "formarraytwocolumns": {
            let myIndex = objectKeys.findIndex(ff => ff.toLowerCase() == templateObject.fieldid.toLowerCase());
            mySonList = objectValues[myIndex] as [{}];
            if (!mySonList) {
              switch (templateObject.captions[0]) {
                case "Name":
                  {
                    mySonList = [{ Name: "", Email: "" }];
                    break;
                  }
                case "Income":
                  {
                    mySonList = [{ Income: "", Description: "" }];
                    break;
                  }
                case "Expense":
                  {
                    mySonList = [{ Expense: "", Description: "" }];
                    break;
                  }
              }
            }
            templateObject.sonListItems = mySonList;
            var objectList = [];
            mySonList.map(group => {
              let myGroup = this.fb.group(group);
              objectList.push(myGroup);
            });
            this.myFormGroup.addControl(templateObject.fieldid, new FormArray(objectList));
            break;
          }
          case "formarraythreecolumns": {
            let myIndex = objectKeys.findIndex(ff => ff.toLowerCase() == templateObject.fieldid.toLowerCase());
            mySonList = objectValues[myIndex] as [{}];
            if (!mySonList) {
              mySonList = [{ Owner: "", Email: "", Percentage: "" }];
            }
            templateObject.sonListItems = mySonList;
            var objectList = [];
            mySonList.map(group => {
              let myGroup = this.fb.group(group);
              objectList.push(myGroup);
            });
            this.myFormGroup.addControl(templateObject.fieldid, new FormArray(objectList));
            break;
          }
          case "formarrayfourcolumns": {
            let myIndex = objectKeys.findIndex(ff => ff.toLowerCase() == templateObject.fieldid.toLowerCase());
            mySonList = objectValues[myIndex] as [{}];
            if (!mySonList) {
              mySonList = [{ Name: "", Email: "", Percentage: "", IncomePercentage: "" }];
            }
            templateObject.sonListItems = mySonList;
            var objectList = [];
            mySonList.map(group => {
              let myGroup = this.fb.group(group);
              objectList.push(myGroup);
            });
            this.myFormGroup.addControl(templateObject.fieldid, new FormArray(objectList));
            break;
            //   let myIndex = objectKeys.findIndex(ff => ff.toLowerCase() == templateObject.fieldid.toLowerCase());
            //   mySonList = objectValues[myIndex] as [{}];
            //   if(!mySonList){
            //     mySonList = [{name:"",email:"",percentage:""}];
            //   }
            //   templateObject.sonListItems = mySonList;
            //   var objectList = [];
            //   mySonList.map(group=>{
            //     let myGroup = this.fb.group(group);
            //     objectList.push(myGroup);
            //    });
            //    this.myFormGroup.addControl(templateObject.fieldid, new FormArray(objectList));
            //    break;
            // }
          }
          default: {
            this.myFormGroup.addControl(templateObject.fieldid, new FormControl(myValue));
            break;
          }
        }
        // if (templateObject.inputtype == "formarray") {
        //   let myIndex = kek.findIndex(ff => ff.toLowerCase() == templateObject.fieldid.toLowerCase());
        //   mySonList = vv[myIndex] as string[];
        //   templateObject.sonListItems = mySonList;
        //   this.myFormGroup.addControl(templateObject.fieldid, new FormArray([]));
        //   //templateObject.sonListItems will be sent to dynamic-son-list and the array will be filled there with the saved data
        // }
      }
      if (templateObject.listSource) {
        templateObject.items = await this.zenplansTestDataProviderService.getSectionItemNames(templateObject.listSource, templateObject.itemType);
      }
      if (templateObject.inputtype == "dropdownshowmultiselect") {
        //Get the dropdownlist
        templateObject.itemArray = await this.zenplansTestDataProviderService.getSectionItemIdsAndNames(templateObject.listSource, templateObject.itemType);
      }
    });
    //fire forkclick now that we have all the fields in place
    var myValue2;
    var kuku = this.myFormTemplate.fields.forEach(async templateObject => {
      if (templateObject.inputtype == "radiobuttons") {
        //myValue = "";
        if (templateObject.urlparameters) {
          templateObject.urlparameters.forEach(up => {
            var sonIndex = objectKeys.findIndex(jj => jj.toLowerCase() === templateObject.fieldid.toLowerCase());
            let myVal = objectValues[sonIndex] as string;
            if (myVal && myVal.length > 0) {
              myValue2 = myVal;
            }
          });
          templateObject.urlparameters.forEach(param => {
            if (param.option == myValue2) {
              this.forkClick(param, templateObject.urlparameters);
            }
          });

        }
      }
      // if (templateObject.inputtype == "conditionaldropdown") {
      //   let localValue = this.myFormGroup.controls[templateObject.fieldid].value;
      //   if (localValue) {
      //     //we need to give the form a kick in order to trigger the hidding/showing of the correct objects
      //     this.changeSelection(null, templateObject.urlparameters, localValue);
      //   }
      // }
      if (templateObject.inputtype.includes("conditionaldropdown")) {
        //adding urls in urlparamters that are fields to the hidelist so they won't show up on init
        // templateObject.urlparameters.forEach(element => {
        //   if (element.urlArray) {
        //     element.urlArray.forEach(objectHideShow => {
        //       // let kk = this.myFormTemplate.fields.find(field => {
        //       //   field.fieldid == url;
        //       // });
        //       // if (kk) {
        //       if (objectHideShow.length > 0) {
        //         this.hideList.push(objectHideShow);
        //       }
        //       //}
        //     });
        //   }

        // })
        let localValue = this.myFormGroup.controls[templateObject.fieldid].value;
        if (localValue) {
          //we need to give the form a kick in order to trigger the hidding/showing of the correct objects
          this.changeSelection(null, templateObject.urlparameters, localValue);
        }
      }
    });
    if (this.myFormTemplate.editInSteps) {
      this.buttonText = "Next";
    }
    this.dummyShowTrigger = true;
    //disable fields that are not shown to prevent validation problems
    this.hideList.map(hiddenField => {
      this.myFormGroup.controls[hiddenField].disable();
    });
    var yy = 0;

  }

  async onSubmit() {

    if (this.myFormGroup.invalid) {
      var kuku = DynamicHelpers.findInvalidControls(this.myFormGroup); //this.findInvalidControls(this.myFormGroup);
      this.submitted = true;
      //this.myFormGroup.setErrors
      //alert("The data in the form is not valid.  Please check that all required fields have been filled in. " + kuku)
      return;
    }
    this.myFormGroup.value["lastUpdate"] = new Date();
    this.myFormGroup.value["lastUpdateBy"] = "Sam";
    if (this.currentReview && this.currentReview != this.myFormGroup.value["review"]) {
      this.myFormGroup.value["upToDateExpire"] = DynamicHelpers.getExpireDate(this.myFormGroup.value["review"]);
    }
    if(this.myFormTemplate.itemNameFields){
      var myItemName="";
      this.myFormTemplate.itemNameFields.map(field=>{
        this.myOptionItem+=this.myFormGroup.value[field]+" ";
      })
      this.myFormGroup.value["item"] = myItemName;
    }
    //need to clear any values of components that were hidden
    DynamicHelpers.clearHiddenFieldValues(this.myFormTemplate, this.myFormGroup);
    let pp = JSON.stringify(this.myFormGroup.value)
    await this.zenplansTestDataProviderService.updateItem(pp, this.myFormTemplate.sectionTitle);
    this.submitted = true;
    //alert(pp);
    if (!this.myFormTemplate.editInSteps) {
      alert('Success :-)'); // \n\n+ JSON.stringify(this.myFormGroup.value, null, 4));
    }
    if (this.myFormTemplate.editInSteps) {
      this.goto(this.myFormTemplate.url + "/" + this.myFormGroup.value["Id"]);
    }
    else {
      this.goto(this.myFormTemplate.url);
    }
  }

  setRadioButton() {

  }

  forkClick(item, elements) {
    //Note: to hide/show the fields we would need to use showMe and add remove fields from this.hideList
    elements.forEach(element => {
      if (element.url[0]) {
        // element.url.map(myUrl=>{
        //   if((item.url as [''])
        // })
        element.url.forEach(element2 => {
          if ((item.url as ['']).includes(element2)) {
            if (this.myFormGroup.controls[element2]) {
              this.myFormGroup.controls[element2].enable();
              this.manageHideFields("show", [element2]);
            }
          }
          else {
            if (this.myFormGroup.controls[element2]) {
              this.myFormGroup.controls[element2].disable();
              this.manageHideFields("hide", [element2]);
            }
            // the field will be disabled and not submitted, so we don't need to reset the content. this.myFormGroup.controls[element.url].setValue("");
          }
        });
      }
      else //simple enable or disable one field per radio click
      {
        if (element.url == item.url) {
          this.myFormGroup.controls[element.url].enable();
        }
        else {
          this.myFormGroup.controls[element.url].disable();
          // the field will be disabled and not submitted, so we don't need to reset the content. this.myFormGroup.controls[element.url].setValue("");
        }
      }
    });
  }

  forkClickYesNo(item) {
    if (item.option == "No") {
      this.goto(item.url);
    }
  }


  showHide(choice, showList) {
    if (choice == "Yes") {
      this.showList = true;
    }
    else {
      this.showList = false;
    }
  }
  showMe(fieldName) {
    if (!this.hideList) { return true; }
    if (this.hideList.length == 0) { return true; }
    if (this.hideList.includes(fieldName)) { return false; }
    else { return true; }
  }

  manageHideFields(choice, showList: string[]) {
    if (choice == "show") {
      showList.map(kk => {
        this.myFormGroup.controls[kk].enable();
        if (this.hideList.includes(kk)) {
          let index = this.hideList.indexOf(kk);
          this.hideList.splice(index, 1);
        }
      })
    }
    else {
      showList.map(kk => {
        this.myFormGroup.controls[kk].disable();
        if (!this.hideList.includes(kk)) {
          this.hideList.push(kk);
        }
      })
    }
    this.dummyShowTrigger = true;
  }

  onOptionSelected(event) {
    let value = event;
    let selected = value;
    console.log(value);
  }
  // forkClick(item, elements) {
  changeSelection(event, urlsParams, alreadySelected?) {
    //in dynamic-edit, "url" means the name fo the field we want to show/hide
    var selected;
    var chosenUrlParameter;
    if (alreadySelected) {
      selected = alreadySelected;
      // let kkkk = urlsParams.find(choice => choice["option"] == alreadySelected)
      // if (!kkkk) {
      //   //the value is not one of the options captions - it must be "other" - meaning the usesr filled in a custom value
      //   this.otherFreeText = true;
      //   selected = "Other";
      //   chosenUrlParameter = urlsParams.find(element =>{
      //     element.option === selected;
      //   });
      //   this.myFormGroup.controls[fieldId].setValue("Other");

      // }
    }
    else {
      selected = event.target.value;
    }
    //this.otherFreeText = selected.trim().toLowerCase() == "other";
    //get the urlParameter for the slected item
    chosenUrlParameter = urlsParams.find(element =>
      element.option === selected
    );

    urlsParams.forEach(param => {
      if (param.urlArray) {
        // element.url.map(myUrl=>{
        //   if((item.url as [''])
        // })
        param.urlArray.forEach(element2 => {
          if ((chosenUrlParameter.urlArray as ['']).includes(element2)) {
            if (this.myFormGroup.controls[element2]) {
              this.myFormGroup.controls[element2].enable();
              this.manageHideFields("show", [element2]);
            }
          }
          else {
            if (this.myFormGroup.controls[element2]) {
              this.myFormGroup.controls[element2].disable();
              this.manageHideFields("hide", [element2]);
            }
            // the field will be disabled and not submitted, so we don't need to reset the content. this.myFormGroup.controls[element.url].setValue("");
          }
        });
      }
      else //simple enable or disable one field per radio click
      {
        //if (param.url[0].length > 0) {
        // if (param.url == chosenUrlParameter.url) {
        //   this.myFormGroup.controls[param.url].enable();
        // }
        // else {
        //   this.myFormGroup.controls[param.url].disable();
        //   // the field will be disabled and not submitted, so we don't need to reset the content. this.myFormGroup.controls[element.url].setValue("");
        // }
        //}
      }
    });
  }

  async getText(key: string) {
    let txt = await this.dictService.getText(key); //this.myTextList.find(kk=>kk.key==key).value;
    return txt;
  }

  goto(url: string) {
    this.router.navigate(['/' + url]);
  }
}
  //   this.myFormTemplate.fields.forEach(kk => {
  //     if (kk.showFields) {
  //       if (kk.inputtype == "radiobuttonsshow") {
  //         kk.options.forEach(option => {
  //           if (option["option"] == this.myFormGroup.value[kk.fieldid] &&
  //             option["action"] == "hide") {
  //             //The user may have chosen hide, leaving data in the hidden objects.
  //             //lets erase any hidden data in the showFields list
  //             kk.showFields.map(fieldId => {
  //               this.myFormGroup.value[fieldId] = "";
  //             });
  //           }
  //         })
  //       }

  //     }
  //     if (kk.inputtype == "formarray") {
  //       //remove array members that are empty
  //       let removeItems: number[] = [];
  //       let itemList = this.myFormGroup.value[kk.fieldid] as string[];
  //       if (!itemList) { return; }
  //       itemList.map((item, index) => {
  //         if (item == null || item == "") {
  //           removeItems.push(index);
  //         }
  //       });
  //       removeItems.map(myIndex => {
  //         itemList.splice(myIndex, 1);
  //       });
  //     }

  //   });
  // }


